import React from "react";
import { CardProps } from "./Card.interface";
import { styles } from "./Card.styles";
import clsx from "clsx";

export const Card = ({ children, style, className }: CardProps) => {
    return <div className={clsx(styles.card, className)} style={style}>
        {children}
    </div>
}